var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 101,
    viewBox: "0 0 61 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4395 6.39402e-05C36.5401 0.0176033 41.5307 0.729297 46.3547 2.43129C49.7041 3.61318 52.8254 5.21196 55.4752 7.62227C57.8673 9.79783 59.5281 12.4004 60.0152 15.654C60.1757 16.7245 60.2021 17.8032 60.0462 18.8792C59.8816 20.0179 59.176 20.6459 58.0292 20.5879C56.4615 20.5083 54.9166 21.0136 53.3508 20.8942C51.8263 20.7775 50.1363 20.8955 48.6117 20.7876C45.97 20.6001 43.3276 20.4159 40.6846 20.2533C39.0082 20.1501 37.3298 20.0752 35.6514 20.0125C33.262 19.9228 30.8713 19.8897 28.4799 19.9396C24.7521 20.0172 21.027 20.1818 17.3066 20.4314C15.0042 20.5859 12.7005 20.7141 10.4001 20.8942C7.74697 21.102 5.23972 20.3957 2.59735 20.7228C2.35382 20.7532 2.10626 20.7579 1.86071 20.7559C0.70918 20.7485 0.172887 20.198 0.114198 19.0532C-0.07064 15.4415 1.17331 12.3653 3.58025 9.72093C5.72073 7.36997 8.3388 5.6835 11.1822 4.32622C15.3046 2.35844 19.6692 1.19746 24.1735 0.537713C26.5811 0.184227 29.0042 -0.00398361 31.4395 6.39402e-05Z",
    fill: "#ED9F48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5424 88.4877C32.5707 88.5193 38.3517 88.4408 42.7557 88.3511C45.9667 88.2862 49.1771 88.1718 52.3868 88.0463C54.8785 87.9489 57.3689 87.8098 59.8586 87.6603C60.2347 87.6381 60.3136 87.7782 60.2962 88.223C60.2447 89.5337 60.3511 90.8486 60.2146 92.1593C59.8834 95.3416 57.7021 98.0867 55.1856 98.4513C52.4818 98.8432 49.7733 99.1651 47.0587 99.4093C44.4646 99.6433 41.8685 99.8141 39.2698 99.9396C35.7068 100.112 32.1438 100.154 28.5795 100.095C25.315 100.041 22.0511 99.9029 18.7913 99.6749C15.4518 99.4418 12.115 99.1446 8.78555 98.7416C7.46742 98.582 6.13322 98.5555 4.83784 98.1516C2.35883 97.378 0.506746 94.4451 0.440505 91.191C0.419093 90.1365 0.441845 89.0812 0.426456 88.0266C0.421772 87.721 0.504768 87.6501 0.730255 87.6621C3.16645 87.7918 5.6033 87.9139 8.04016 88.0318C9.06924 88.0813 10.0983 88.1283 11.1281 88.1539C14.7593 88.2461 18.3891 88.3921 22.0217 88.41C22.8888 88.4143 23.756 88.4493 24.6231 88.4647C24.755 88.4672 24.8954 88.5168 25.0159 88.3981C25.6013 89.4517 26.514 88.4561 29.5424 88.4877Z",
    fill: "#ED9F48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 26.4H19.2002V28.8001H21.6002V26.4Z",
    fill: "#9E4802"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 26.4H21.6006V28.8001H24.0006V26.4Z",
    fill: "#9E4802"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 26.4001H24.001V28.8001H26.401V26.4001Z",
    fill: "#9E4802"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6002 26.4H31.2002V28.8001H33.6002V26.4Z",
    fill: "#9E4802"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 26.4H33.6006V28.8H36.0006V26.4Z",
    fill: "#9E4802"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 26.4H38.3994V28.8H40.7994V26.4Z",
    fill: "#9E4802"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 28.8H19.2002V31.2001H21.6002V28.8Z",
    fill: "#9E4802"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 28.8H21.6006V31.2001H24.0006V28.8Z",
    fill: "#9E4802"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 28.8001H26.4014V31.2001H28.8014V28.8001Z",
    fill: "#9E4802"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 28.8H28.7998V31.2H31.1998V28.8Z",
    fill: "#9E4802"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 28.8001H33.6006V31.2001H36.0006V28.8001Z",
    fill: "#9E4802"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 28.8001H38.3994V31.2001H40.7994V28.8001Z",
    fill: "#9E4802"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 31.2001H19.2002V33.6001H21.6002V31.2001Z",
    fill: "#9E4802"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 31.2001H21.6006V33.6001H24.0006V31.2001Z",
    fill: "#9E4802"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 31.2001H24.001V33.6001H26.401V31.2001Z",
    fill: "#9E4802"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 31.2001H26.4014V33.6001H28.8014V31.2001Z",
    fill: "#9E4802"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6002 31.2001H31.2002V33.6001H33.6002V31.2001Z",
    fill: "#9E4802"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 31.2001H36.001V33.6001H38.401V31.2001Z",
    fill: "#9E4802"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 31.2001H38.3994V33.6001H40.7994V31.2001Z",
    fill: "#9E4802"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 33.6001H21.6006V36.0001H24.0006V33.6001Z",
    fill: "#9E4802"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6002 33.6001H31.2002V36.0001H33.6002V33.6001Z",
    fill: "#9E4802"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 33.6H33.6006V36.0001H36.0006V33.6Z",
    fill: "#9E4802"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 33.6H38.3994V36.0001H40.7994V33.6Z",
    fill: "#9E4802"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 36.0001H24.001V38.4001H26.401V36.0001Z",
    fill: "#9E4802"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 36.0001H28.7998V38.4001H31.1998V36.0001Z",
    fill: "#9E4802"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 36.0002H38.3994V38.4002H40.7994V36.0002Z",
    fill: "#9E4802"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 38.4001H19.2002V40.8002H21.6002V38.4001Z",
    fill: "#9E4802"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 38.4001H24.001V40.8002H26.401V38.4001Z",
    fill: "#9E4802"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 38.4001H28.7998V40.8002H31.1998V38.4001Z",
    fill: "#9E4802"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 38.4001H33.6006V40.8002H36.0006V38.4001Z",
    fill: "#9E4802"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 38.4001H38.3994V40.8002H40.7994V38.4001Z",
    fill: "#9E4802"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 40.8002H19.2002V43.2002H21.6002V40.8002Z",
    fill: "#3E9300"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 40.8001H33.6006V43.2001H36.0006V40.8001Z",
    fill: "#3E9300"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40003 43.2002H0V45.6002H2.40003V43.2002Z",
    fill: "#3E9300"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8004 43.2002H14.4004V45.6002H16.8004V43.2002Z",
    fill: "#3E9300"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 43.2002H19.2002V45.6002H21.6002V43.2002Z",
    fill: "#3E9300"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 43.2002H24.001V45.6002H26.401V43.2002Z",
    fill: "#3E9300"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 43.2002H28.7998V45.6002H31.1998V43.2002Z",
    fill: "#3E9300"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6002 43.2002H31.2002V45.6002H33.6002V43.2002Z",
    fill: "#3E9300"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 43.2002H40.7998V45.6002H43.1998V43.2002Z",
    fill: "#3E9300"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 43.2003H43.2002V45.6003H45.6002V43.2003Z",
    fill: "#3E9300"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 43.2002H50.4004V45.6002H52.8004V43.2002Z",
    fill: "#3E9300"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2008 43.2002H52.8008V45.6002H55.2008V43.2002Z",
    fill: "#3E9300"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6012 43.2002H55.2012V45.6002H57.6012V43.2002Z",
    fill: "#3E9300"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80042 45.6002H2.40039V48.0002H4.80042V45.6002Z",
    fill: "#3E9300"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 45.6002H9.59961V48.0002H11.9996V45.6002Z",
    fill: "#3E9300"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 45.6002H12V48.0002H14.4V45.6002Z",
    fill: "#3E9300"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 45.6002H19.2002V48.0002H21.6002V45.6002Z",
    fill: "#3E9300"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 45.6002H26.4014V48.0002H28.8014V45.6002Z",
    fill: "#3E9300"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 45.6002H36.001V48.0002H38.401V45.6002Z",
    fill: "#3E9300"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 45.6002H40.7998V48.0002H43.1998V45.6002Z",
    fill: "#3E9300"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0006 45.6002H45.6006V48.0002H48.0006V45.6002Z",
    fill: "#3E9300"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 45.6002H48V48.0002H50.4V45.6002Z",
    fill: "#3E9300"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 45.6002H50.4004V48.0002H52.8004V45.6002Z",
    fill: "#3E9300"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2008 45.6002H52.8008V48.0002H55.2008V45.6002Z",
    fill: "#3E9300"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6012 45.6002H55.2012V48.0002H57.6012V45.6002Z",
    fill: "#3E9300"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40003 48.0002H0V50.4003H2.40003V48.0002Z",
    fill: "#F99A0B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80042 48.0002H2.40039V50.4003H4.80042V48.0002Z",
    fill: "#F99A0B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 48.0002H12V50.4002H14.4V48.0002Z",
    fill: "#F99A0B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8004 48.0002H14.4004V50.4003H16.8004V48.0002Z",
    fill: "#F99A0B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2008 48.0002H16.8008V50.4003H19.2008V48.0002Z",
    fill: "#F99A0B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 48.0002H21.6006V50.4003H24.0006V48.0002Z",
    fill: "#F99A0B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 48.0003H24.001V50.4003H26.401V48.0003Z",
    fill: "#F99A0B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 48.0003H28.7998V50.4003H31.1998V48.0003Z",
    fill: "#F99A0B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 48.0003H36.001V50.4003H38.401V48.0003Z",
    fill: "#F99A0B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 48.0002H43.2002V50.4003H45.6002V48.0002Z",
    fill: "#F99A0B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0006 48.0002H45.6006V50.4003H48.0006V48.0002Z",
    fill: "#F99A0B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 48.0002H50.4004V50.4003H52.8004V48.0002Z",
    fill: "#F99A0B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6012 48.0003H55.2012V50.4003H57.6012V48.0003Z",
    fill: "#F99A0B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 48.0002H57.5996V50.4002H59.9996V48.0002Z",
    fill: "#F99A0B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40003 50.4003H0V52.8003H2.40003V50.4003Z",
    fill: "#F99A0B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80042 50.4003H2.40039V52.8004H4.80042V50.4003Z",
    fill: "#F99A0B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20081 50.4003H4.80078V52.8003H7.20081V50.4003Z",
    fill: "#F99A0B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6012 50.4003H7.20117V52.8003H9.6012V50.4003Z",
    fill: "#F99A0B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 50.4003H9.59961V52.8003H11.9996V50.4003Z",
    fill: "#F99A0B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 50.4003H12V52.8003H14.4V50.4003Z",
    fill: "#F99A0B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2008 50.4003H16.8008V52.8004H19.2008V50.4003Z",
    fill: "#F99A0B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 50.4003H19.2002V52.8003H21.6002V50.4003Z",
    fill: "#F99A0B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 50.4003H21.6006V52.8004H24.0006V50.4003Z",
    fill: "#F99A0B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 50.4003H24.001V52.8003H26.401V50.4003Z",
    fill: "#F99A0B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 50.4003H26.4014V52.8003H28.8014V50.4003Z",
    fill: "#F99A0B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 50.4003H28.7998V52.8003H31.1998V50.4003Z",
    fill: "#F99A0B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 50.4003H36.001V52.8003H38.401V50.4003Z",
    fill: "#F99A0B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 50.4003H38.3994V52.8003H40.7994V50.4003Z",
    fill: "#F99A0B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 50.4003H50.4004V52.8003H52.8004V50.4003Z",
    fill: "#F99A0B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 50.4003H57.5996V52.8003H59.9996V50.4003Z",
    fill: "#F99A0B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40003 52.8003H0V55.2003H2.40003V52.8003Z",
    fill: "#F99A0B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80042 52.8003H2.40039V55.2003H4.80042V52.8003Z",
    fill: "#F99A0B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6012 52.8003H7.20117V55.2003H9.6012V52.8003Z",
    fill: "#F99A0B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8004 52.8003H14.4004V55.2003H16.8004V52.8003Z",
    fill: "#F99A0B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2008 52.8003H16.8008V55.2003H19.2008V52.8003Z",
    fill: "#F99A0B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 52.8003H21.6006V55.2003H24.0006V52.8003Z",
    fill: "#F99A0B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 52.8003H26.4014V55.2003H28.8014V52.8003Z",
    fill: "#F99A0B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 52.8003H28.7998V55.2003H31.1998V52.8003Z",
    fill: "#F99A0B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 52.8003H38.3994V55.2003H40.7994V52.8003Z",
    fill: "#F99A0B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 52.8003H43.2002V55.2003H45.6002V52.8003Z",
    fill: "#F99A0B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 52.8003H57.5996V55.2003H59.9996V52.8003Z",
    fill: "#F99A0B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40003 55.2003H0V57.6003H2.40003V55.2003Z",
    fill: "#F99A0B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80042 55.2003H2.40039V57.6003H4.80042V55.2003Z",
    fill: "#F99A0B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 55.2004H9.59961V57.6004H11.9996V55.2004Z",
    fill: "#F99A0B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 55.2003H19.2002V57.6003H21.6002V55.2003Z",
    fill: "#F99A0B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 55.2003H21.6006V57.6003H24.0006V55.2003Z",
    fill: "#F99A0B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6002 55.2003H31.2002V57.6003H33.6002V55.2003Z",
    fill: "#F99A0B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 55.2004H33.6006V57.6004H36.0006V55.2004Z",
    fill: "#F99A0B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 55.2004H36.001V57.6004H38.401V55.2004Z",
    fill: "#F99A0B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 55.2004H40.7998V57.6004H43.1998V55.2004Z",
    fill: "#F99A0B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0006 55.2003H45.6006V57.6003H48.0006V55.2003Z",
    fill: "#F99A0B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6012 55.2004H55.2012V57.6004H57.6012V55.2004Z",
    fill: "#F99A0B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40003 57.6004H0V60.0004H2.40003V57.6004Z",
    fill: "#3E9300"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20081 57.6003H4.80078V60.0004H7.20081V57.6003Z",
    fill: "#3E9300"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6012 57.6003H7.20117V60.0004H9.6012V57.6003Z",
    fill: "#3E9300"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 57.6003H12V60.0004H14.4V57.6003Z",
    fill: "#3E9300"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8004 57.6004H14.4004V60.0004H16.8004V57.6004Z",
    fill: "#3E9300"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2008 57.6003H16.8008V60.0004H19.2008V57.6003Z",
    fill: "#3E9300"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 57.6004H19.2002V60.0004H21.6002V57.6004Z",
    fill: "#3E9300"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 57.6003H26.4014V60.0004H28.8014V57.6003Z",
    fill: "#3E9300"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 57.6003H28.7998V60.0004H31.1998V57.6003Z",
    fill: "#3E9300"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 57.6003H36.001V60.0004H38.401V57.6003Z",
    fill: "#3E9300"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 57.6003H43.2002V60.0004H45.6002V57.6003Z",
    fill: "#3E9300"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0006 57.6004H45.6006V60.0004H48.0006V57.6004Z",
    fill: "#3E9300"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 57.6003H48V60.0004H50.4V57.6003Z",
    fill: "#3E9300"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 57.6004H50.4004V60.0004H52.8004V57.6004Z",
    fill: "#3E9300"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6012 57.6003H55.2012V60.0004H57.6012V57.6003Z",
    fill: "#3E9300"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 57.6003H57.5996V60.0004H59.9996V57.6003Z",
    fill: "#3E9300"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40003 60.0004H0V62.4004H2.40003V60.0004Z",
    fill: "#3E9300"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20081 60.0004H4.80078V62.4004H7.20081V60.0004Z",
    fill: "#3E9300"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 60.0004H24.001V62.4004H26.401V60.0004Z",
    fill: "#3E9300"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 60.0004H26.4014V62.4004H28.8014V60.0004Z",
    fill: "#3E9300"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 60.0004H40.7998V62.4004H43.1998V60.0004Z",
    fill: "#3E9300"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0006 60.0004H45.6006V62.4004H48.0006V60.0004Z",
    fill: "#3E9300"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 60.0004H50.4004V62.4004H52.8004V60.0004Z",
    fill: "#3E9300"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2008 60.0004H52.8008V62.4004H55.2008V60.0004Z",
    fill: "#3E9300"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 60.0004H57.5996V62.4004H59.9996V60.0004Z",
    fill: "#3E9300"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40003 62.4004H0V64.8004H2.40003V62.4004Z",
    fill: "#3E9300"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6012 62.4005H7.20117V64.8005H9.6012V62.4005Z",
    fill: "#3E9300"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 62.4005H9.59961V64.8005H11.9996V62.4005Z",
    fill: "#3E9300"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 62.4005H12V64.8005H14.4V62.4005Z",
    fill: "#3E9300"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8004 62.4004H14.4004V64.8004H16.8004V62.4004Z",
    fill: "#3E9300"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 62.4004H19.2002V64.8004H21.6002V62.4004Z",
    fill: "#3E9300"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 62.4005H26.4014V64.8005H28.8014V62.4005Z",
    fill: "#3E9300"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 62.4005H28.7998V64.8005H31.1998V62.4005Z",
    fill: "#3E9300"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6002 62.4004H31.2002V64.8004H33.6002V62.4004Z",
    fill: "#3E9300"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 62.4005H33.6006V64.8005H36.0006V62.4005Z",
    fill: "#3E9300"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 62.4005H36.001V64.8005H38.401V62.4005Z",
    fill: "#3E9300"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 62.4005H38.3994V64.8005H40.7994V62.4005Z",
    fill: "#3E9300"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 62.4005H40.7998V64.8005H43.1998V62.4005Z",
    fill: "#3E9300"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 62.4004H43.2002V64.8004H45.6002V62.4004Z",
    fill: "#3E9300"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0006 62.4004H45.6006V64.8004H48.0006V62.4004Z",
    fill: "#3E9300"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 62.4004H48V64.8004H50.4V62.4004Z",
    fill: "#3E9300"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2008 62.4005H52.8008V64.8005H55.2008V62.4005Z",
    fill: "#3E9300"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 64.8005H19.2002V67.2005H21.6002V64.8005Z",
    fill: "#F99A0B"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 64.8004H21.6006V67.2004H24.0006V64.8004Z",
    fill: "#F99A0B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 64.8004H24.001V67.2004H26.401V64.8004Z",
    fill: "#F99A0B"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 64.8004H28.7998V67.2004H31.1998V64.8004Z",
    fill: "#F99A0B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 64.8004H38.3994V67.2004H40.7994V64.8004Z",
    fill: "#F99A0B"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 64.8004H48V67.2004H50.4V64.8004Z",
    fill: "#F99A0B"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 67.2005H21.6006V69.6005H24.0006V67.2005Z",
    fill: "#9E4802"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 67.2005H26.4014V69.6005H28.8014V67.2005Z",
    fill: "#9E4802"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 67.2005H28.7998V69.6005H31.1998V67.2005Z",
    fill: "#9E4802"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 67.2005H33.6006V69.6005H36.0006V67.2005Z",
    fill: "#9E4802"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 67.2005H38.3994V69.6005H40.7994V67.2005Z",
    fill: "#9E4802"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 67.2005H43.2002V69.6005H45.6002V67.2005Z",
    fill: "#9E4802"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 67.2005H48V69.6005H50.4V67.2005Z",
    fill: "#9E4802"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 67.2005H57.5996V69.6005H59.9996V67.2005Z",
    fill: "#9E4802"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 69.6005H26.4014V72.0006H28.8014V69.6005Z",
    fill: "#9E4802"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 69.6005H28.7998V72.0006H31.1998V69.6005Z",
    fill: "#9E4802"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 69.6005H36.001V72.0006H38.401V69.6005Z",
    fill: "#9E4802"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 69.6005H38.3994V72.0006H40.7994V69.6005Z",
    fill: "#9E4802"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 69.6005H48V72.0005H50.4V69.6005Z",
    fill: "#9E4802"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6012 69.6005H55.2012V72.0006H57.6012V69.6005Z",
    fill: "#9E4802"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 69.6005H57.5996V72.0006H59.9996V69.6005Z",
    fill: "#9E4802"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 72.0005H28.7998V74.4005H31.1998V72.0005Z",
    fill: "#9E4802"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6002 72.0005H31.2002V74.4006H33.6002V72.0005Z",
    fill: "#9E4802"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 72.0005H33.6006V74.4005H36.0006V72.0005Z",
    fill: "#9E4802"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 72.0005H36.001V74.4005H38.401V72.0005Z",
    fill: "#9E4802"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 72.0005H38.3994V74.4005H40.7994V72.0005Z",
    fill: "#9E4802"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 72.0005H40.7998V74.4005H43.1998V72.0005Z",
    fill: "#9E4802"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 72.0005H43.2002V74.4005H45.6002V72.0005Z",
    fill: "#9E4802"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0006 72.0005H45.6006V74.4006H48.0006V72.0005Z",
    fill: "#9E4802"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 72.0005H48V74.4005H50.4V72.0005Z",
    fill: "#9E4802"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2008 72.0005H52.8008V74.4005H55.2008V72.0005Z",
    fill: "#9E4802"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 74.4006H21.6006V76.8006H24.0006V74.4006Z",
    fill: "#9E4802"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 74.4006H24.001V76.8006H26.401V74.4006Z",
    fill: "#9E4802"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 74.4006H26.4014V76.8006H28.8014V74.4006Z",
    fill: "#9E4802"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6002 74.4005H31.2002V76.8005H33.6002V74.4005Z",
    fill: "#9E4802"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 74.4006H36.001V76.8006H38.401V74.4006Z",
    fill: "#9E4802"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 74.4006H38.3994V76.8006H40.7994V74.4006Z",
    fill: "#9E4802"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 74.4006H40.7998V76.8006H43.1998V74.4006Z",
    fill: "#9E4802"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 74.4006H43.2002V76.8006H45.6002V74.4006Z",
    fill: "#9E4802"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6012 74.4006H55.2012V76.8006H57.6012V74.4006Z",
    fill: "#9E4802"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 74.4006H57.5996V76.8006H59.9996V74.4006Z",
    fill: "#9E4802"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 76.8006H40.7998V79.2006H43.1998V76.8006Z",
    fill: "#9E4802"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 76.8005H50.4004V79.2006H52.8004V76.8005Z",
    fill: "#9E4802"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2008 76.8006H52.8008V79.2006H55.2008V76.8006Z",
    fill: "#9E4802"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 76.8006H57.5996V79.2006H59.9996V76.8006Z",
    fill: "#9E4802"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 79.2006H21.6006V81.6006H24.0006V79.2006Z",
    fill: "#9E4802"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M26.401 79.2006H24.001V81.6006H26.401V79.2006Z",
    fill: "#9E4802"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8014 79.2006H26.4014V81.6006H28.8014V79.2006Z",
    fill: "#9E4802"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M38.401 79.2006H36.001V81.6006H38.401V79.2006Z",
    fill: "#9E4802"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 79.2006H38.3994V81.6006H40.7994V79.2006Z",
    fill: "#9E4802"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 79.2006H40.7998V81.6006H43.1998V79.2006Z",
    fill: "#9E4802"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 79.2006H43.2002V81.6006H45.6002V79.2006Z",
    fill: "#9E4802"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0006 79.2006H45.6006V81.6006H48.0006V79.2006Z",
    fill: "#9E4802"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 79.2006H48V81.6006H50.4V79.2006Z",
    fill: "#9E4802"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 79.2006H57.5996V81.6006H59.9996V79.2006Z",
    fill: "#9E4802"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6002 81.6006H19.2002V84.0006H21.6002V81.6006Z",
    fill: "#9E4802"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1998 81.6006H28.7998V84.0007H31.1998V81.6006Z",
    fill: "#9E4802"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7994 81.6006H38.3994V84.0007H40.7994V81.6006Z",
    fill: "#9E4802"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 81.6006H40.7998V84.0007H43.1998V81.6006Z",
    fill: "#9E4802"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6002 81.6006H43.2002V84.0007H45.6002V81.6006Z",
    fill: "#9E4802"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 81.6006H50.4004V84.0006H52.8004V81.6006Z",
    fill: "#9E4802"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 81.6006H57.5996V84.0007H59.9996V81.6006Z",
    fill: "#9E4802"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0644 24.0015H5.73575C3.13878 24.0015 0.938626 25.7173 0.235202 28.0624C0.162458 28.305 0.105673 28.5543 0.0661927 28.8092C0.0226802 29.0904 0 29.3784 0 29.6715V35.1267C0 38.2547 2.57379 40.7985 5.73575 40.7985L8.40009 40.799L11.0644 40.7983C14.2262 40.7983 16.8002 38.2546 16.8002 35.1265V29.6715C16.8002 26.545 14.2264 24.0015 11.0644 24.0015ZM14.2802 35.1267C14.2802 36.8645 12.8377 38.2784 11.0638 38.2784L8.40009 38.2789L5.73642 38.2783C3.96249 38.2783 2.52003 36.8644 2.52003 35.1267V29.6715C2.52003 29.1287 2.66081 28.6177 2.90861 28.1711C3.14718 27.7415 3.48469 27.3721 3.89109 27.0924C4.41357 26.7327 5.0498 26.5215 5.73558 26.5215H11.0644C12.8377 26.5215 14.2802 27.9346 14.2802 29.6715V35.1267Z",
    fill: "#9E4802"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2646 24.0014H48.9359C46.339 24.0014 44.1388 25.7172 43.4354 28.0623C43.3627 28.3049 43.3059 28.5543 43.2664 28.8091C43.2229 29.0903 43.2002 29.3783 43.2002 29.6715V35.1266C43.2002 38.2547 45.774 40.7984 48.9359 40.7984L51.6003 40.7989L54.2646 40.7982C57.4264 40.7982 60.0004 38.2545 60.0004 35.1265V29.6715C60.0004 26.545 57.4266 24.0014 54.2646 24.0014ZM57.4803 35.1266C57.4803 36.8645 56.0379 38.2784 54.264 38.2784L51.6003 38.2789L48.9366 38.2782C47.1627 38.2782 45.7202 36.8643 45.7202 35.1266V29.6715C45.7202 29.1287 45.861 28.6176 46.1088 28.171C46.3474 27.7415 46.6849 27.372 47.0913 27.0923C47.6138 26.7326 48.25 26.5214 48.9358 26.5214H54.2646C56.0379 26.5214 57.4803 27.9345 57.4803 29.6715V35.1266Z",
    fill: "#9E4802"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0644 67.2018H5.73575C3.13878 67.2018 0.938626 68.9176 0.235202 71.2628C0.162458 71.5054 0.105673 71.7547 0.0661927 72.0096C0.0226802 72.2908 0 72.5787 0 72.8719V78.3271C0 81.4551 2.57379 83.9988 5.73575 83.9988L8.40009 83.9993L11.0644 83.9987C14.2262 83.9987 16.8002 81.4549 16.8002 78.3269V72.8719C16.8002 69.7454 14.2264 67.2018 11.0644 67.2018ZM14.2802 78.3271C14.2802 80.0649 12.8377 81.4788 11.0638 81.4788L8.40009 81.4793L5.73642 81.4786C3.96249 81.4786 2.52003 80.0647 2.52003 78.3271V72.8719C2.52003 72.3291 2.66081 71.818 2.90861 71.3715C3.14718 70.9419 3.48469 70.5725 3.89109 70.2927C4.41357 69.933 5.0498 69.7219 5.73558 69.7219H11.0644C12.8377 69.7219 14.2802 71.1349 14.2802 72.8719V78.3271Z",
    fill: "#9E4802"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77108 36.0002C5.68459 36.0002 4.80078 35.1339 4.80078 34.07V30.7293C4.80078 30.3969 4.88718 30.0842 5.03846 29.8105C5.18455 29.5471 5.39133 29.3207 5.64038 29.15C5.96028 28.9298 6.35024 28.8001 6.77 28.8001H10.0336C11.1191 28.8001 12.0029 29.6654 12.0029 30.7292V34.0699C12.0029 35.1337 11.1191 36.0001 10.0336 36.0001H8.40183L6.77108 36.0002Z",
    fill: "#9E4802"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9723 36.0001C48.8858 36.0001 48.002 35.1338 48.002 34.0699V30.7292C48.002 30.3968 48.0884 30.084 48.2396 29.8104C48.3857 29.547 48.5925 29.3206 48.8416 29.1498C49.1615 28.9297 49.5514 28.8 49.9712 28.8H53.2348C54.3202 28.8 55.204 29.6653 55.204 30.7291V34.0698C55.204 35.1336 54.3203 36 53.2348 36H51.603L49.9723 36.0001Z",
    fill: "#9E4802"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77108 79.2005C5.68459 79.2005 4.80078 78.3342 4.80078 77.2703V73.9296C4.80078 73.5973 4.88718 73.2845 5.03846 73.0108C5.18455 72.7474 5.39133 72.5211 5.64038 72.3503C5.96028 72.1301 6.35024 72.0004 6.77 72.0004H10.0336C11.1191 72.0004 12.0029 72.8657 12.0029 73.9295V77.2702C12.0029 78.334 11.1191 79.2004 10.0336 79.2004H8.40183L6.77108 79.2005Z",
    fill: "#9E4802"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger-icon.5042646d648a7417d5009aa2e5a21af6.svg";
export { ForwardRef as ReactComponent };